import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ModalHeader,
} from "./Atom"
import { useSelector } from "react-redux"
import { modalContainerStyles } from "../Atom"
import { makeFullName } from "../../../../helper/utils"

type Props = {}

const UserActivationConfirmation = (props: any) => {
  const {
    open,
    setOpen,
    type,
    selectedUser,
    deactivateUser,
    reactivateUser,
    isGroup,
    setIsActivationButtonDisabled,
    isUser,
  } = props

  const handleClose = () => {
    // type == "new" ? handleRemoveNewTab() : type == "edit" ? setCurrentActiveEditBucketName(-1) : type == "del" ? "" : "";
    setOpen(false)
  }

  return (
    <Modal
      sx={{
        "& .css-5ta5m7 ": { width: "fit-content" },
        "& .MuiTypography-root": { whiteSpace: "nowrap" },
      }}
      open={open}
      onClose={() => {
        handleClose()
        setIsActivationButtonDisabled && setIsActivationButtonDisabled(false)
      }}
      aria-labelledby="groupInfo-modal-title"
      aria-describedby="groupInfo-modal-description"
    >
      <Box sx={modalContainerStyles}>
        <ModalHeader>
          <Typography variant={"h2"} fontSize={"18px"} fontWeight={500}>
            {type == "deActivate" ? "Deactivate" : "Reactivate "}{" "}
            {isGroup ? "Group" : "User"}
          </Typography>
          <CloseIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              handleClose()
              setIsActivationButtonDisabled &&
                setIsActivationButtonDisabled(false)
            }}
          />
        </ModalHeader>

        <Typography
          id="modal-modal-title"
          fontSize={"18px"}
          fontWeight={500}
          sx={{
            padding: "10px 24px 30px 24px",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          {type == "deActivate" ? (
            <>
              Are you sure to deactivate the {isGroup ? "group " : "user "}
              <b>
                {isGroup
                  ? selectedUser?.group_name
                  : isUser
                  ? selectedUser?.name
                  : `"${selectedUser?.first_name} ${selectedUser?.last_name}"`}
              </b>{" "}
              ?
            </>
          ) : type == "reActivate" ? (
            <>
              Are you sure to reactivate the {isGroup ? "group " : "user "}
              <b>
                {isGroup
                  ? selectedUser?.group_name
                  : isUser
                  ? selectedUser?.name
                  : `"${selectedUser?.first_name} ${selectedUser?.last_name}"`}
              </b>{" "}
              ?
            </>
          ) : (
            <></>
          )}
        </Typography>

        <br />
        {/* <Divider /> */}

        <ButtonContainer>
          <CancelButton
            onClick={() => {
              handleClose()
              setIsActivationButtonDisabled &&
                setIsActivationButtonDisabled(false)
            }}
          >
            <Typography color={"#4A79E7"}>Cancel</Typography>
          </CancelButton>
          <ConfirmButton
            onClick={async () => {
              type == "deActivate"
                ? deactivateUser(selectedUser?.uid)
                : type == "reActivate"
                ? reactivateUser(selectedUser?.uid)
                : ""
              handleClose()
            }}
          >
            <Typography color={"#ffffff"}>Yes</Typography>
          </ConfirmButton>
        </ButtonContainer>
      </Box>
    </Modal>
  )
}

export default UserActivationConfirmation
